import React, { useEffect, useState, useCallback } from 'react';
import AlertCard from '../../components/Teacher/AlertCard';
import ConversationModal from '../../components/Teacher/ConversationModal';

const TIER_LABELS = {
  1: '즉시 개입 필요 (Tier 1)',
  2: '빠른 확인 (Tier 2)',
  3: '관찰 (Tier 3)',
};

function authHeaders() {
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export default function AlertsPage() {
  const [alerts, setAlerts] = useState([]);
  const [modalAlertId, setModalAlertId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/teacher/alerts', {
        credentials: 'include',
        headers: authHeaders(),
      });
      if (!res.ok) { setError(`HTTP ${res.status}`); return; }
      const body = await res.json();
      setAlerts(body.alerts || []);
      setError(null);
    } catch (e) { setError(String(e.message || e)); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleReview = useCallback(async (alertId, verdict, note) => {
    const res = await fetch(`/api/teacher/alerts/${alertId}/review`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify({ verdict, note }),
    });
    if (res.ok) setAlerts(prev => prev.filter(a => a.id !== alertId));
  }, []);

  if (loading) return <div>로딩…</div>;
  if (error) return <div>불러오기 실패: {error}</div>;

  const grouped = { 1: [], 2: [], 3: [] };
  for (const a of alerts) grouped[a.severity]?.push(a);

  return (
    <div className="alerts-page">
      <h2>위험 신호 알림</h2>
      {[1, 2, 3].map(tier => (
        <section key={tier} className={`tier tier--${tier}`}>
          <h3>{TIER_LABELS[tier]} <span className="tier__count">{grouped[tier].length}건</span></h3>
          {grouped[tier].map(a =>
            <AlertCard key={a.id} alert={a} onReview={handleReview}
              onDetail={setModalAlertId} />
          )}
        </section>
      ))}
      {modalAlertId && <ConversationModal alertId={modalAlertId}
        onClose={() => setModalAlertId(null)} />}
    </div>
  );
}
